
// // src/pages/Workflow/WorkflowHome.jsx
// import React, { useState, useEffect } from "react";
// import { DragDropContext, Droppable, Draggable } from "react-beautiful-dnd";
// import api from "../../utils/api";
// import TaskCard from "../../components/Task/TaskCard";
// import CreateTaskModal from "../../components/Task/CreateTaskModal";
// import TaskDetailDrawer from "../../components/Task/TaskDetailDrawer";

// const columnsConfig = [
//   { id: "todo", title: "To Do", statuses: ["Pending"] },
//   { id: "inprogress", title: "In Progress", statuses: ["In Progress"] },
//   { id: "waiting", title: "Waiting/Approval", statuses: ["Needs Approval"] },
//   { id: "completed", title: "Completed", statuses: ["Completed", "Approved", "Rejected"] },
// ];

// const statusMap = {
//   todo: "Pending",
//   inprogress: "In Progress",
//   waiting: "Needs Approval",
//   completed: "Completed", // or Approved/Rejected — we'll keep it simple
// };

// export default function WorkflowHome() {
//   const [tasks, setTasks] = useState([]);
//   const [filteredTasks, setFilteredTasks] = useState([]);
//   const [loading, setLoading] = useState(true);

//   const [filters, setFilters] = useState({
//     view: "All Tasks",
//     company: "All",
//     module: "All",
//     status: "All",
//     priority: "All",
//   });

//   const [showCreate, setShowCreate] = useState(false);
//   const [selectedTask, setSelectedTask] = useState(null);

//   const user = JSON.parse(localStorage.getItem("user") || "{}");
//   const isManager = ["Admin", "SuperAdmin", "TeamLead"].includes(user.role || "");

//   const loadTasks = async () => {
//     setLoading(true);
//     try {
//       const endpoint = isManager ? "/tasks?team=true" : "/tasks?mine=true";
//       const { data } = await api.get(endpoint);
//       setTasks(data.tasks || []);
//     } catch (err) {
//       console.error("Failed to load tasks", err);
//     } finally {
//       setLoading(false);
//     }
//   };

//   useEffect(() => {
//     loadTasks();
//   }, []);

//   // Apply filters
//   useEffect(() => {
//     let result = tasks;

//     if (filters.view === "My Tasks") {
//       result = result.filter(t => t.assignee_id === user.id || t.assigned_to === user.id);
//     }
//     if (filters.company !== "All") result = result.filter(t => t.company_name === filters.company);
//     if (filters.module !== "All") result = result.filter(t => t.module === filters.module);
//     if (filters.status !== "All") result = result.filter(t => t.status === filters.status);
//     if (filters.priority !== "All") result = result.filter(t => t.priority === filters.priority);

//     setFilteredTasks(result);
//   }, [tasks, filters, user.id]);

//   // Group tasks by column
//   const columns = columnsConfig.map(col => ({
//     ...col,
//     tasks: filteredTasks.filter(t => col.statuses.includes(t.status))
//   }));

//   // Handle drag end
//   const onDragEnd = async (result) => {
//     if (!result.destination) return;

//     const { source, destination, draggableId } = result;

//     if (source.droppableId === destination.droppableId && source.index === destination.index) {
//       return; // no change
//     }

//     const taskId = parseInt(draggableId);
//     const newStatus = statusMap[destination.droppableId];

//     // Optimistic UI update
//     setTasks(prev => prev.map(t =>
//       t.id === taskId ? { ...t, status: newStatus } : t
//     ));

//     // Call API to update status
//     try {
//       await api.patch(`/tasks/${taskId}`, { status: newStatus });
//     } catch (err) {
//       alert("Failed to update task status");
//       loadTasks(); // rollback
//     }
//   };

//   return (
//     <div className="min-h-screen bg-gray-50 dark:bg-gray-900">
//       <div className="max-w-7xl mx-auto p-6">

//         {/* Top Bar */}
//         <div className="flex flex-col lg:flex-row justify-between items-start lg:items-center gap-6 mb-10">
//           <h1 className="text-4xl font-extrabold text-gray-900 dark:text-white">Workflow</h1>

//           <div className="flex flex-wrap items-center gap-4">
//             <select
//               value={filters.view}
//               onChange={(e) => setFilters({ ...filters, view: e.target.value })}
//               className="px-6 py-3 bg-white dark:bg-gray-800 border border-gray-300 dark:border-gray-600 rounded-xl font-medium"
//             >
//               <option>All Tasks</option>
//               <option>My Tasks</option>
//               {isManager && <option>Team Tasks</option>}
//             </select>

//             <select
//               value={filters.priority}
//               onChange={(e) => setFilters({ ...filters, priority: e.target.value })}
//               className="px-6 py-3 bg-white dark:bg-gray-800 border border-gray-300 dark:border-gray-600 rounded-xl font-medium"
//             >
//               <option value="All">All Priority</option>
//               <option>High</option>
//               <option>Medium</option>
//               <option>Low</option>
//             </select>

//             <button
//               onClick={() => setShowCreate(true)}
//               className="px-8 py-3 bg-blue-600 hover:bg-blue-700 text-white font-bold text-lg rounded-xl shadow-lg transition flex items-center gap-3"
//             >
//               + Create Task
//             </button>
//           </div>
//         </div>

//         {/* Filters Row */}
//         <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-5 gap-4 mb-10">
//           <select value={filters.company} onChange={e => setFilters({ ...filters, company: e.target.value })} className="px-4 py-3 bg-white dark:bg-gray-800 border rounded-xl">
//             <option value="All">All Companies</option>
//             {/* Add real companies here */}
//           </select>

//           <select value={filters.module} onChange={e => setFilters({ ...filters, module: e.target.value })} className="px-4 py-3 bg-white dark:bg-gray-800 border rounded-xl">
//             <option value="All">All Modules</option>
//             <option>Lead</option>
//             <option>Project</option>
//             <option>Invoice</option>
//             <option>Service</option>
//             <option>HR</option>
//           </select>

//           <select value={filters.status} onChange={e => setFilters({ ...filters, status: e.target.value })} className="px-4 py-3 bg-white dark:bg-gray-800 border rounded-xl">
//             <option value="All">All Status</option>
//             <option>Pending</option>
//             <option>In Progress</option>
//             <option>Needs Approval</option>
//             <option>Completed</option>
//           </select>
//         </div>

//         {/* Kanban with Drag & Drop */}
//         <DragDropContext onDragEnd={onDragEnd}>
//           {loading ? (
//             <div className="text-center py-20 text-2xl text-gray-500">Loading...</div>
//           ) : (
//             <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
//               {columns.map((column) => (
//                 <Droppable key={column.id} droppableId={column.id}>
//                   {(provided, snapshot) => (
//                     <div
//                       ref={provided.innerRef}
//                       {...provided.droppableProps}
//                       className={`bg-white dark:bg-gray-800 rounded-3xl shadow-xl p-8 border-2 transition-all
//                         ${snapshot.isDraggingOver ? "border-blue-500 bg-blue-50 dark:bg-blue-900/20" : "border-gray-200 dark:border-gray-700"}
//                       `}
//                     >
//                       <div className="flex justify-between items-center mb-8">
//                         <h2 className="text-2xl font-bold text-gray-900 dark:text-white">
//                           {column.title}
//                         </h2>
//                         <span className="text-2xl font-bold text-blue-600">
//                           {column.tasks.length}
//                         </span>
//                       </div>

//                       <div className="space-y-6">
//                         {column.tasks.length === 0 ? (
//                           <p className="text-center text-gray-400 py-16 text-lg">
//                             No tasks — drop here
//                           </p>
//                         ) : (
//                           column.tasks.map((task, index) => (
//                             <Draggable key={task.id} draggableId={task.id.toString()} index={index}>
//                               {(provided, snapshot) => (
//                                 <div
//                                   ref={provided.innerRef}
//                                   {...provided.draggableProps}
//                                   {...provided.dragHandleProps}
//                                   className={`${snapshot.isDragging ? "opacity-70 scale-105" : ""}`}
//                                 >
//                                   <TaskCard
//                                     task={task}
//                                     onClick={() => setSelectedTask(task)}
//                                   />
//                                 </div>
//                               )}
//                             </Draggable>
//                           ))
//                         )}
//                         {provided.placeholder}
//                       </div>
//                     </div>
//                   )}
//                 </Droppable>
//               ))}
//             </div>
//           )}
//         </DragDropContext>
//       </div>

//       <CreateTaskModal
//         open={showCreate}
//         onClose={(success) => {
//           setShowCreate(false);
//           if (success) loadTasks();
//         }}
//       />

//       <TaskDetailDrawer
//         task={selectedTask}
//         open={!!selectedTask}
//         onClose={() => setSelectedTask(null)}
//         onMarkComplete={async (taskId) => {
//           await api.post(`/tasks/${taskId}/complete`);
//           loadTasks();
//         }}
//       />
//     </div>
//   );
// }

//drag and drop feature

// import React, { useState, useEffect } from "react";
// import api from "../../utils/api";
// import TaskCard from "../../components/Task/TaskCard";
// import CreateTaskModal from "../../components/Task/CreateTaskModal";
// import TaskDetailDrawer from "../../components/Task/TaskDetailDrawer";

// const columns = [
//   { id: "todo", title: "To Do", statuses: ["Pending"] },
//   { id: "inprogress", title: "In Progress", statuses: ["In Progress"] },
//   { id: "waiting", title: "Waiting/Approval", statuses: ["Needs Approval"] },
//   { id: "completed", title: "Completed", statuses: ["Completed", "Approved"] },
// ];

// export default function WorkflowHome() {
//   const [tasks, setTasks] = useState([]);
//   const [filteredTasks, setFilteredTasks] = useState([]);
//   const [filters, setFilters] = useState({
//     view: "All Tasks",
//     priority: "All",
//     module: "All",
//     status: "All",
//   });
//   const [showCreate, setShowCreate] = useState(false);
//   const [selectedTask, setSelectedTask] = useState(null);

//   const user = JSON.parse(localStorage.getItem("user") || "{}");
//   const isManager = ["Admin", "SuperAdmin", "TeamLead"].includes(user.role);

//   const loadTasks = async () => {
//     const endpoint = isManager ? "/tasks?team=true" : "/tasks?mine=true";
//     const { data } = await api.get(endpoint);
//     setTasks(data.tasks || []);
//   };

//   useEffect(() => {
//     loadTasks();
//   }, []);

//   useEffect(() => {
//     let result = tasks;
//     if (filters.view === "My Tasks") result = result.filter(t => t.assignee_id === user.id);
//     if (filters.priority !== "All") result = result.filter(t => t.priority === filters.priority);
//     if (filters.module !== "All") result = result.filter(t => t.module === filters.module);
//     if (filters.status !== "All") result = result.filter(t => t.status === filters.status);
//     setFilteredTasks(result);
//   }, [tasks, filters]);

//   const getColumnTasks = (column) => filteredTasks.filter(t => column.statuses.includes(t.status));

//   return (
//     <div className="p-6 min-h-screen bg-gray-50 dark:bg-gray-900">
//       <div className="max-w-7xl mx-auto">
//         {/* Top Bar */}
//         <div className="flex flex-col md:flex-row justify-between items-start md:items-center mb-8 gap-4">
//           <h1 className="text-3xl font-bold text-gray-900 dark:text-white">Workflow</h1>

//           <div className="flex flex-wrap gap-3 items-center">
//             <select
//               value={filters.view}
//               onChange={e => setFilters({ ...filters, view: e.target.value })}
//               className="px-4 py-2 bg-white dark:bg-gray-800 border rounded-lg"
//             >
//               <option>All Tasks</option>
//               <option>My Tasks</option>
//               {isManager && <option>Team Tasks</option>}
//             </select>

//             <select
//               value={filters.priority}
//               onChange={e => setFilters({ ...filters, priority: e.target.value })}
//               className="px-4 py-2 bg-white dark:bg-gray-800 border rounded-lg"
//             >
//               <option value="All">All Priority</option>
//               <option>High</option>
//               <option>Medium</option>
//               <option>Low</option>
//             </select>

//             <button
//               onClick={() => setShowCreate(true)}
//               className="px-6 py-2.5 bg-blue-600 hover:bg-blue-700 text-white font-medium rounded-lg flex items-center gap-2"
//             >
//               + Create Task
//             </button>
            
//           </div>
//         </div>

//         {/* Kanban Board */}
//         <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6">
//           {columns.map(column => (
//             <div key={column.id} className="bg-gray-100 dark:bg-gray-800 rounded-2xl p-6 min-h-[600px]">
//               <h3 className="font-bold text-lg mb-6 text-gray-900 dark:text-white flex justify-between">
//                 {column.title}
//                 <span className="text-sm bg-gray-200 dark:bg-gray-700 px-3 py-1 rounded-full">
//                   {getColumnTasks(column).length}
//                 </span>
//               </h3>

//               <div className="space-y-4">
//                 {getColumnTasks(column).map(task => (
//                   <TaskCard
//                     key={task.id}
//                     task={task}
//                     onClick={() => setSelectedTask(task)}
//                   />
//                 ))}
//               </div>
//             </div>
//           ))}
//         </div>
//       </div>

//       <CreateTaskModal open={showCreate} onClose={(success) => { setShowCreate(false); if (success) loadTasks(); }} />
//      <TaskDetailDrawer
//   task={selectedTask}
//   open={!!selectedTask}
//   onClose={() => setSelectedTask(null)}
// />
//     </div>
//   );
// }



// // src/pages/Workflow/WorkflowHome.jsx
// import React, { useState, useEffect } from "react";
// import api from "../../utils/api";
// import TaskCard from "../../components/Task/TaskCard";
// import CreateTaskModal from "../../components/Task/CreateTaskModal";
// import TaskDetailDrawer from "../../components/Task/TaskDetailDrawer";

// const columns = [
//   { id: "todo", title: "To Do", statuses: ["Pending"] },
//   { id: "inprogress", title: "In Progress", statuses: ["In Progress"] },
//   { id: "waiting", title: "Waiting/Approval", statuses: ["Needs Approval"] },
//   { id: "completed", title: "Completed", statuses: ["Completed", "Approved"] },
// ];

// export default function WorkflowHome() {
//   const [tasks, setTasks] = useState([]);
//   const [filteredTasks, setFilteredTasks] = useState([]);
//   const [filters, setFilters] = useState({
//     view: "All Tasks",
//     priority: "All",
//     module: "All",
//     status: "All",
//   });
//   const [showCreate, setShowCreate] = useState(false);
//   const [selectedTask, setSelectedTask] = useState(null);

//   const user = JSON.parse(localStorage.getItem("user") || "{}");
//   const isManager = ["Admin", "SuperAdmin", "TeamLead"].includes(user.role);

// const loadTasks = async () => {
//   try {
//     const endpoint = isManager ? "/tasks?team=true" : "/tasks?mine=true";
//     const { data } = await api.get(endpoint);
//     setTasks(data.tasks || []);
//   } catch (err) {
//     console.error("Failed to load tasks");
//   }
// };
//   useEffect(() => {
//     loadTasks();
//   }, []);

//   useEffect(() => {
//     let result = tasks;
//     if (filters.view === "My Tasks") result = result.filter(t => t.assignee_id === user.id);
//     if (filters.priority !== "All") result = result.filter(t => t.priority === filters.priority);
//     if (filters.module !== "All") result = result.filter(t => t.module === filters.module);
//     if (filters.status !== "All") result = result.filter(t => t.status === filters.status);
//     setFilteredTasks(result);
//   }, [tasks, filters]);

//   const getColumnTasks = (column) => filteredTasks.filter(t => column.statuses.includes(t.status));

//   // Fixed: Added handleCreateSuccess
//   const handleCreateSuccess = () => {
//     setShowCreate(false);
//     loadTasks();
//   };

//   return (
//     <div className="p-6 min-h-screen bg-gray-50 dark:bg-gray-900">
//       <div className="max-w-7xl mx-auto">
//         {/* Top Bar */}
//         <div className="flex flex-col md:flex-row justify-between items-start md:items-center mb-8 gap-4">
//           <h1 className="text-3xl font-bold text-gray-900 dark:text-white">Workflow</h1>

//           <div className="flex flex-wrap gap-3 items-center">
//             <select
//               value={filters.view}
//               onChange={e => setFilters({ ...filters, view: e.target.value })}
//               className="px-4 py-2 bg-white dark:bg-gray-800 border rounded-lg"
//             >
//               <option>All Tasks</option>
//               <option>My Tasks</option>
//               {isManager && <option>Team Tasks</option>}
//             </select>

//             <select
//               value={filters.priority}
//               onChange={e => setFilters({ ...filters, priority: e.target.value })}
//               className="px-4 py-2 bg-white dark:bg-gray-800 border rounded-lg"
//             >
//               <option value="All">All Priority</option>
//               <option>High</option>
//               <option>Medium</option>
//               <option>Low</option>
//             </select>

//             {/* Fixed: Button is now just a regular <button>, no MUI import needed */}
//             <button
//               onClick={() => setShowCreate(true)}
//               className="px-6 py-2.5 bg-blue-600 hover:bg-blue-700 text-white font-medium rounded-lg flex items-center gap-2"
//             >
//               + Create Task
//             </button>
//           </div>
//         </div>

//         {/* Kanban Board */}
//         <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6">
//           {columns.map(column => (
//             <div key={column.id} className="bg-gray-100 dark:bg-gray-800 rounded-2xl p-6 min-h-[600px]">
//               <h3 className="font-bold text-lg mb-6 text-gray-900 dark:text-white flex justify-between">
//                 {column.title}
//                 <span className="text-sm bg-gray-200 dark:bg-gray-700 px-3 py-1 rounded-full">
//                   {getColumnTasks(column).length}
//                 </span>
//               </h3>

//               <div className="space-y-4">
//                 {getColumnTasks(column).map(task => (
//                   <TaskCard
//                     key={task.id}
//                     task={task}
//                     onClick={() => setSelectedTask(task)}
//                   />
//                 ))}
//               </div>
//             </div>
//           ))}
//         </div>
//       </div>

//   <CreateTaskModal 
//   open={showCreate} 
//   onClose={(success) => {
//     setShowCreate(false);
//     if (success) loadTasks();
//   }} 
// />     {/* Fixed: Removed unused onMarkComplete prop since drawer is read-only */}
//       <TaskDetailDrawer
//         task={selectedTask}
//         open={!!selectedTask}
//         onClose={() => setSelectedTask(null)}
//       />
//     </div>
//   );
// }

// src/pages/Workflow/WorkflowHome.jsx
import React, { useState, useEffect } from "react";
import api from "../../utils/api";
import CreateTaskDrawer from "../../components/Task/CreateTaskModal";
import TaskDetailDrawer from "../../components/Task/TaskDetailDrawer";

const columns = [
  { id: "todo", title: "To Do", statuses: ["Pending"], color: "bg-orange-50 border-orange-400" },
  { id: "inprogress", title: "In Progress", statuses: ["In Progress"], color: "bg-yellow-50 border-yellow-400" },
  { id: "waiting", title: "Waiting/Approval", statuses: ["Needs Approval"], color: "bg-red-50 border-red-400" },
  { id: "completed", title: "Completed", statuses: ["Completed", "Approved"], color: "bg-blue-50 border-blue-400" },
];

export default function WorkflowHome() {
  const [tasks, setTasks] = useState([]);
  const [showCreate, setShowCreate] = useState(false);
  const [selectedTask, setSelectedTask] = useState(null);

  const user = JSON.parse(localStorage.getItem("user") || "{}");
  const isManager = ["Admin", "SuperAdmin", "TeamLead"].includes(user.role);

  const loadTasks = async () => {
    try {
      const endpoint = isManager ? "/tasks?team=true" : "/tasks?mine=true";
      const { data } = await api.get(endpoint);
      setTasks(data.tasks || []);
    } catch (err) {
      console.error("Failed to load tasks");
    }
  };

  useEffect(() => {
    loadTasks();
  }, []);

  const getColumnTasks = (column) => {
    return tasks.filter((t) => column.statuses.includes(t.status));
  };

  const handleCompleteTask = async (taskId, e) => {
    e.stopPropagation();
    try {
      await api.post(`/tasks/${taskId}/complete`);
      loadTasks();
    } catch (err) {
      alert("Failed to complete task");
    }
  };

  return (
    <div className="min-h-screen bg-gray-100">
      <div className="max-w-7xl mx-auto p-6">
        {/* Header */}
        <div className="flex justify-between items-center mb-8">
          <h1 className="text-3xl font-bold text-gray-900">Workflow</h1>
          <button
            onClick={() => setShowCreate(true)}
            className="px-6 py-3 bg-blue-600 hover:bg-blue-700 text-white font-medium rounded-lg flex items-center gap-2 transition"
          >
            + Create Task
          </button>
        </div>

        {/* Kanban Board */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6">
          {columns.map((column) => {
            const columnTasks = getColumnTasks(column);
            return (
              <div
                key={column.id}
                className="bg-white rounded-2xl shadow-sm border-t-4 border-gray-300 p-6"
              >
                <div className="flex justify-between items-center mb-6">
                  <h3 className="text-lg font-semibold text-gray-900">{column.title}</h3>
                  <span className="bg-gray-200 text-gray-700 px-3 py-1 rounded-full text-sm font-medium">
                    {columnTasks.length}
                  </span>
                </div>

                <div className="space-y-4">
                  {columnTasks.length === 0 ? (
                    <p className="text-center text-gray-400 py-8 text-sm">No tasks here</p>
                  ) : (
                    columnTasks.map((task) => (
                      <div
                        key={task.id}
                        onClick={() => setSelectedTask(task)}
                        className={`p-5 rounded-xl border-2 ${column.color} cursor-pointer hover:shadow-md transition-shadow`}
                      >
                        <h4 className="font-semibold text-gray-900 mb-3">{task.title}</h4>

                        <div className="text-sm text-gray-600 space-y-2">
                          <div className="flex items-center gap-2">
                            <span className="font-medium">Assigned:</span>
                            <span>{task.assignee?.name || "Unassigned"}</span>
                          </div>

                          <div className="flex items-center gap-2">
                            <span className="font-medium">Due:</span>
                            <span>
                              {task.due_date
                                ? new Date(task.due_date).toLocaleDateString("en-GB", {
                                    day: "numeric",
                                    month: "numeric",
                                    year: "numeric",
                                  })
                                : "—"}
                            </span>
                          </div>
                        </div>

                        {/* Mark Complete Button */}
                        {["Pending", "In Progress"].includes(task.status) && (
                          <button
                            onClick={(e) => handleCompleteTask(task.id, e)}
                            className="mt-4 w-full py-2 bg-green-600 hover:bg-green-700 text-white text-sm font-medium rounded-lg flex items-center justify-center gap-2 transition"
                          >
                            Mark Complete
                          </button>
                        )}
                      </div>
                    ))
                  )}
                </div>
              </div>
            );
          })}
        </div>
      </div>

      {/* Drawers */}
      <CreateTaskDrawer
        open={showCreate}
        onClose={(success) => {
          setShowCreate(false);
          if (success) loadTasks();
        }}
      />

      <TaskDetailDrawer
        task={selectedTask}
        open={!!selectedTask}
        onClose={() => setSelectedTask(null)}
      />
    </div>
  );
}